export const enum AccountUserTabs {
  BASIC_INFO = "Basic Info",
}
